import axios from "axios";

const publicRequest = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const privateRequest = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

publicRequest.interceptors.request.use((req) => {
  req.headers["Accept-Language"] = "fa";
  delete req.headers.Authorization;
  return req;
});

privateRequest.interceptors.request.use((req) => {
  req.headers["Accept-Language"] = "fa";
  const accessToken = `Bearer ${localStorage.getItem("accessToken")}`;
  req.headers["Authorization"] = accessToken;
  return req;
});

export { publicRequest, privateRequest };
